import { Component } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { environment } from '../../../environments/environment.development';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-review-rating',
  templateUrl: './review-rating.component.html',
  styleUrl: './review-rating.component.scss'
})
export class ReviewRatingComponent {

  myRatingImageUrl = environment.ImageBaseUrl;
  userrating: any[] = [];
  errorMessage: string = '';
  loading: boolean = true;

  constructor(private api:ApiServiceService ,private Loader:LoaderService){

  }

  ngOnInit(): void {
    this.userratinginfo();
  }


  userratinginfo(): void {
    this.Loader.showLoader();
    this.api.userReviews().subscribe(
      (response : any) => {
        this.Loader.hideLoader();
        this.userrating = response.data.reviews; // Bind response data to the component
        this.loading = false;
      },
      (error : any) => {
        this.errorMessage = error.error.message || 'Failed to fetch transactions';
        this.loading = false;
        this.Loader.hideLoader();
      }
    );
  }

}


